// extracted by mini-css-extract-plugin
export default {"segment":"BuilderSegment_segment__ArFBq","disabled":"BuilderSegment_disabled__i3Qum"};